/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { CORE_CONFIG, I18nService } from '@dm/core';

@Injectable({
    providedIn: 'root',
})

export class QuickStartService {
    get = this.i18nService.get;


    i18n = {
        quickStartTitle: this.get('home.quickstart_task_DM_title'),
        quickStartContent: this.get('home.quickstart_task_desc'),
        dontPromptLabel: this.get('home.quickstart_task_noNoticeAgain_checkbox'),
        quickstartExportLab: this.get('home.quickstart_task_export_lab'),
        closeBtn: this.get('common.close_button'),
        quickStartBtn: this.get('home.quickstart_task_start_btn'),
        learnMoreTip: `${this.get('settings.eService_introduce_knowMore_btn')}>>`,
        title: this.get('home.commonTask_term_title'),
        createLunGroupBtn: this.get('home.commonTask_term_createLunGroup_button'),
        createHostBtn: this.get('home.commonTask_term_createHost_button'),
        createLunBtn: this.get('storage.lun_task_create_title'),
        createHostGroupBtn: this.get('host.hostGroup_task_create_hostGroup_button'),
        createPgBtn: this.get('home.commonTask_term_createPG_button'),
        createSnapshotCgBtn: this.get('home.commonTask_term_createSnapshotCG_button'),
        createCloneCgBtn: this.get('home.commonTask_term_createHyperCloneCG_button'),
        createHyperMetroCgBtn: this.get('home.commonTask_term_createhyperMetroCG_button'),
        createReplicationCgBtn: this.get('home.commonTask_term_createReplicationCG_button'),
        createFileSystemBtn: this.get('service.fileSystem_term_create_title'),
        createNfsShareBtn: this.get('service.share_term_createNFS_title'),
        createDtreeBtn: this.get('service.dtree_term_create_title'),
        createFSsnapBtn: this.get('home.quickstart_task_createFSsnap_btn'),
        createFSreplicationBtn: this.get('home.quickstart_task_createFSreplication_btn'),

        hostTab: this.get('common.hosts_title'),
        lunGroupTab: this.get('common.lunGroup_title'),
        lunTab: this.get('common.lun_title'),
        hostGroupTab: this.get('common.hostGroups_title'),
        pgTab: this.get('protection.protectionGroup_title'),
        snapshotCgTab: this.get('protection.snapshotCGs_title'),
        replicationCgTab: this.get('protection.replicationCG_title'),
        hyperMetroCgTab: this.get('protection.hyperMetroCGs_title'),
        fileSystemTab: this.get('common.fileSystem_title'),
        nfsShareTab: this.get('common.nfsShare_lab'),
        dtreeTab: this.get('common.dtree_lab'),
        snapshotFs: this.get('common.snapshots'),
        replicationCG: this.get('protection.replicationCG_title'),
        resourceDistributeTitle: this.get('common.resourceDistribute_title'),
        dataProtectionTitle: this.get('common.dataProtection_title'),
        replicationFS: this.i18nService.get('common.RemoteReplicationPairs'),
        batchConfigLabel: this.get('common.batchConfig_label'),
        exportDataLabel: this.get('system.exportData_task_title_label'),
    };

    language = this.i18nService.getLanguage();

    constructor(
        private i18nService: I18nService,
    ) {
    }

    /**
     * 获取新手引导链接
     * @param page 要跳转的新手引导页面地址（不传入默认跳转到首页）
     */
    getQuickStartUrl(page?: string): string {
        let url: string;
        const helpMap = CORE_CONFIG.helpMap;
        const quickStartPath = 'Quickstart';
        if (helpMap) {
            const location = window.location;
            const baseUrl = `${location.protocol}//${location.host}`;
            const defalutPage = `index-${this.language === 'ja' ? 'en' : this.language}.html`;
            url = `${baseUrl + helpMap.rootPath}/${quickStartPath}/${page || defalutPage}`;
        }
        return url;
    }
}
